module.exports = __webpack_public_path__ + "img/grafico-3.c83d61dd.svg";